function ErrorComponent() {
  return <div>Unable to load disputes</div>;
}

export default ErrorComponent;
